import {generateCdnAssetsUrl} from "./helpers";

// /icons/...
export const ArrowDownBlueIconUrl = generateCdnAssetsUrl(`icons/arrow-down-blue.svg`);
export const ArrowRightGreyIconUrl = generateCdnAssetsUrl(`icons/arrow-right-grey.svg`);
export const ArrowUpBlueIconUrl = generateCdnAssetsUrl(`icons/arrow-up-blue.svg`);
export const injuryGreenUrl = generateCdnAssetsUrl(`icons/injury-green.svg`);
export const injuryRedUrl = generateCdnAssetsUrl(`icons/injury-red.svg`);
export const injuryYellowUrl = generateCdnAssetsUrl(`icons/injury-yellow.svg`);
export const searchUrl = generateCdnAssetsUrl(`icons/search.svg`);
export const tickUrl = generateCdnAssetsUrl(`icons/tick.svg`);
export const eyeUrl = generateCdnAssetsUrl(`icons/eye.svg`);
export const clipboardUrl = generateCdnAssetsUrl(`icons/clipboard.svg`);
export const chevronDownIconBlack = generateCdnAssetsUrl(`icons/chevron-down.svg`);

// /event-details/...
export const WhistleIconUrl = generateCdnAssetsUrl(`event-details/whistle.svg`);
export const StadiumIconUrl = generateCdnAssetsUrl(`event-details/stadium.svg`);
export const LocationIconUrl = generateCdnAssetsUrl(`event-details/location.svg`);

export const getWeatherIconSrc = (icon: number | undefined) => icon ? generateCdnAssetsUrl(`event-details/weather/${icon}.png`) : generateCdnAssetsUrl(`event-details/weather/1.png`);

export const getWindIconSrc = (direction: string) => generateCdnAssetsUrl(`event-details/wind/${direction.toLowerCase()}.png`)

export const getHumidityIconSrc = () => generateCdnAssetsUrl(`event-details/humidity.svg`)

export const getTemperatureIconSrc = () => generateCdnAssetsUrl(`event-details/temperature/temperature.svg`)
